import {IsHRWeb, UsePagination, storeData} from './DisplayTools';
import * as myDate from './DateTools';

export function SetWindowSearch(search) {
  global.windows.list[global.windows.curwindow].cursearch =
    search.toLowerCase();
  global.windows.list[global.windows.curwindow].UpdateWindowData();
}

export function SetWindowStartDate(date) {
  global.windows.list[global.windows.curwindow].curstartdate = date;
  global.windows.list[global.windows.curwindow].UpdateWindowData();
}

export function SetWindowEndDate(date) {
  global.windows.list[global.windows.curwindow].curenddate = date;
  global.windows.list[global.windows.curwindow].UpdateWindowData();
}

export function UpdateWindowData2() {
  global.windows.list[global.windows.curwindow].UpdateWindowData();
}

export function GetWindowSearch(search) {
  return global.windows.list[global.windows.curwindow].cursearch;
}
export function GetFilterStartDate() {
  let res = global.windows.list[global.windows.curwindow].curstartdate;
  return res;
}

export function GetFilterEndDate() {
  let res = global.windows.list[global.windows.curwindow].curenddate;
  return res;
}
export function WindowHasDateFilter() {
  return global.windows.list[global.windows.curwindow].datefilter;
}

export function AddWindowFilter(window, field, value) {
  global.windows.list[window].customsearch[field] = value;
}
export function AddDateFilter(window, td) {
  if (td === undefined) {
    td = myDate.AddYear(myDate.CurrentDate(), -1);
  }
  global.windows.list[window].curstartdate = myDate.ConstructDateString2(td);
  global.windows.list[window].curenddate = '';
  global.windows.list[window].datefilter = true;
}
export function GetWindowFilter(window, field, value) {
  return global.windows.list[window].customsearch[field];
}

export function UpdateWindowData(cursort, curdir) {
  let curwin = global.windows.curwindow;
  global.windows.list[curwin].cursort = cursort;
  global.windows.list[curwin].curdir = curdir;
  global.windows.list[curwin].UpdateWindowData();
  UpdateWindowDefaults(curwin, cursort, curdir);
}

export function SetCurrentWindow(curwin, defsort, defdir) {
  global.windows.curwindow = curwin;
  if (global.windows.list[curwin]) {
  } else {
    global.windows.list[curwin] = {};
    global.windows.list[curwin].cursort = defsort;
    global.windows.list[curwin].curdir = defdir;
    global.windows.list[curwin].cursearch = '';
    global.windows.list[curwin].customsearch = {};
  }
}

export function SetCurrentWindow2(curwin, tdefsort, defdir) {
  let defsort = tdefsort;
  if (UsePagination() == false) {
    defsort = defsort.toLowerCase();
  }
  global.windows.curwindow = curwin;
  if (global.windows.list[curwin]) {
  } else {
    global.windows.list[curwin] = {};
    global.windows.list[curwin].cursort = defsort;
    global.windows.list[curwin].curdir = defdir;
    global.windows.list[curwin].cursearch = '';
    global.windows.list[curwin].customsearch = {};
  }
}

export function SetWindowDefaults() {
  let list = global.windowStates;
  for (let i in list) {
    global.windows.list[i] = {};
    global.windows.list[i].cursort = list[i].cursort;
    global.windows.list[i].curdir = list[i].curdir;
    global.windows.list[i].cursearch = '';
    global.windows.list[i].customsearch = {};
  }
}
export function UpdateWindowDefaults(curwin, cursort, curdir) {
  if (global.windowStates.hasOwnProperty(curwin) == false) {
    global.windowStates[curwin] = {};
  }

  global.windowStates[curwin].cursort = cursort;
  global.windowStates[curwin].curdir = curdir;

  let data = JSON.stringify(global.windowStates);
  if (IsHRWeb()) {
    document.cookie = 'windowstates=' + data;
  } else {
    storeData('@windowstates', data);
  }
}
